<template>
	<div class="head_img">
		<img :src="imgurl">
	</div>
</template>

<script>
export default {
	props: {
		imgurl: {
			type: String,
			required: true,
		},
	},
}
</script>

<style lang="scss">
.head_img {
	img {
		width: 100%;
		height: auto;
	}
}
@media screen and (min-width: 1600px) {
	.head_img {
		min-width: 1000px;
		img {
			width: 100%;
			height: auto;
		}
	}
}
</style>